import { ShippingMethod } from '@app/types/cart/ShippingMethod';
import { Box, constants, Stack, Text } from '@redbubble/design-system';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import React from 'react';

import { CheckoutButton } from '../CheckoutButton';
import styles from './Shipping.module.scss';

export const messages = defineMessages({
  deliversToday: {
    defaultMessage: 'Delivers today',
  },
});

export const DigitalShipping = () => {
  const intl = useIntl();

  return (
    <Box className={styles.wrapper}>
      <Stack spacing="xs">
        <Text type="body2" textAlign={constants.CENTER} muted display="block">
          {intl.formatMessage(messages.deliversToday)}
        </Text>
        <CheckoutButton shippingMethod={ShippingMethod.Standard} />
      </Stack>
    </Box>
  );
};
